import React from 'react';
import { ChevronRight, ChevronLeft } from "lucide-react";
import { useTranslation } from 'react-i18next';

const Paginator = ({ page, rows, totalRecords, onPageChange }) => {
  const totalPages = Math.ceil(totalRecords / rows);
  const maxVisiblePages = 10; // Number of visible page buttons
  const halfVisiblePages = Math.floor(maxVisiblePages / 2);
      const { t, i18n } = useTranslation();
      const isRTL = i18n.language === 'ar';

  // Generate page numbers with ellipsis
  const getPageNumbers = () => {
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    let startPage = Math.max(1, page - halfVisiblePages);
    let endPage = Math.min(totalPages, page + halfVisiblePages);

    // Adjust if we're at the beginning
    if (page <= halfVisiblePages) {
      endPage = maxVisiblePages;
    }
    // Adjust if we're at the end
    else if (page >= totalPages - halfVisiblePages) {
      startPage = totalPages - maxVisiblePages + 1;
    }

    const pages = [];
    
    // Always show first page
    if (startPage > 1) {
      pages.push(1);
      if (startPage > 2) {
        pages.push('...');
      }
    }

    // Middle pages
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Always show last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push('...');
      }
      pages.push(totalPages);
    }

    return pages;
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && newPage !== page) {
      onPageChange(newPage);
    }
  };

  return (
    <nav aria-label="Page navigation">
      <ul className={`pagination justify-content-center ${isRTL ? 'flex-row-reverse' : ''}`}>
        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
          <button
            size="sm"
            variant="link"
            className="paginator-btn"
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
          >
            <ChevronLeft size={18} />

          </button>
        </li>

        {getPageNumbers().map((pageNumber, index) => (
          <li
            key={index}
            className={`page-item ${
              pageNumber === page ? 'active' : 
              pageNumber === '...' ? 'disabled' : ''
            }`}
          >
            {pageNumber === '...' ? (
              <span className="page-link">...</span>
            ) : (
              <button
                className="paginator-btn"
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </button>
            )}
          </li>
        ))}

        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
          <button
            className="paginator-btn"
            onClick={() => handlePageChange(page + 1)}
            disabled={page === totalPages}
          >
            <ChevronRight size={18} />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Paginator;